import actionTypes from '../../actions/bill/settle/actionType';

const defaultSettleInfo = {
  consumeAmount: 0, // 已消费金额
  ota: 0, // ota预付款
  payAmount: 0, // 已付款金额
  payDeposit: 0, // 已付押金
  refundDeposit: 0, // 应退押金
  settleAmount: 0, // <0 应付房费，=0 确认结账，>0 应退房费
  waitPayment: 0, // 待支付金额
};

const initialState = {
  drawerVisible: false,

  orderStateLoading: false,
  orderState: 0, // 订单状态(1: 预订订单, 2: 入住订单, 3: 预订取消订单, 4: 退房订单)

  roomChecked: 1, // 是否已查房(1已查房，0未查房)
  step: 0, // 结账步骤

  orderInfoLoading: false,
  orderInfo: {
    cancelReservationList: [], // 取消预订列表
    checkOutRoomList: [], // 退房列表
    overtimePriceAdjustList: [], // 超时冲调列表
  },

  checkRoomListLoading: false,
  checkRoomList: [], // 查房列表

  settleInfoLoading: false,
  settleInfo: defaultSettleInfo, // 结账信息

  overStayModalVisible: false,
  overStayListLoading: false,
  overStayList: [], // 续住明细列表
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_SETTLE_DRAWER_VISIBLE:
      const { drawerVisible } = payload;
      return {
        ...state,
        drawerVisible,
      };

    case actionTypes.SET_ORDER_STATE_LOADING:
      const { orderStateLoading } = payload;
      return {
        ...state,
        orderStateLoading,
      };
    case actionTypes.INIT_ORDER_STATE:
      const { orderState } = payload;
      return {
        ...state,
        orderState,
      };
    case actionTypes.SET_ORDER_STATE:
      return {
        ...state,
        ...payload,
      };

    case actionTypes.SET_SETTLE_STEP:
      const { step } = payload;
      return {
        ...state,
        step,
      };

    case actionTypes.SET_ORDER_INFO_LOADING:
      const { orderInfoLoading } = payload;
      return {
        ...state,
        orderInfoLoading,
      };
    case actionTypes.FETCH_ORDER_INFO:
      const { orderInfo } = payload;
      return {
        ...state,
        orderInfo,
      };
    case actionTypes.UPDATE_ORDER_INFO:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.RESET_ORDER_INFO:
      return {
        ...state,
        orderInfo: {
          cancelReservationList: [],
          checkOutRoomList: [],
          overtimePriceAdjustList: [],
        },
      };

    case actionTypes.SET_CHECK_ROOM_LIST_LOADING:
      const { checkRoomListLoading } = payload;
      return {
        ...state,
        checkRoomListLoading,
      };
    case actionTypes.FETCH_CHECK_ROOM_LIST:
      const { checkRoomList } = payload;
      return {
        ...state,
        checkRoomList,
      };

    case actionTypes.SET_SETTLE_INFO_LOADING:
      const { settleInfoLoading } = payload;
      return {
        ...state,
        settleInfoLoading,
      };
    case actionTypes.FETCH_SETTLE_INFO:
      const { settleInfo } = payload;
      return {
        ...state,
        settleInfo,
      };

    case actionTypes.TOGGLE_OVERSTAY_MODAL_VISIBLE:
      const { overStayModalVisible } = payload;
      return {
        ...state,
        overStayModalVisible,
      };
    case actionTypes.SET_OVERSTAY_LIST_LOADING:
      const { overStayListLoading } = payload;
      return {
        ...state,
        overStayListLoading,
      };
    case actionTypes.INIT_OVERSTAY_LIST:
      const { overStayList } = payload;
      return {
        ...state,
        overStayList,
      };
    case actionTypes.UPDATE_OVERSTAY_LIST:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
